import React, { useEffect } from 'react';
import Header from '../components/services/Header';
import Services from '../components/services/Services';
import { useLocation } from 'react-router-dom';

const ServicePage = () => {

    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <div className='bg-[#F4F7FD] h-full md:py-10 py-5 xl:px-20'>
            <div className="">
                <Header />
                <Services />
            </div>
        </div>
    );
};

export default ServicePage;